module.exports = __webpack_public_path__ + "static/img/9.48fbe72.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/zh/9.png
// module id = ROi2
// module chunks = 0